import React, { useEffect } from "react";
import { AutoComplete, Divider, Tag } from "antd";
import { fetchUsers_CM_Atomizer, fetchUsers_demoted } from "../../API/api";
import Styles from "./ExpertRecordsStyles.module.css";
import { CloseCircleOutlined } from "@ant-design/icons";
import MultiSelectCm from "../MultiSelectCm/MultiSelectCm";

export default function UsersFilter({ state, onChangeFunc, onRemoveFunc }) {
  const [seekers, setSeekers] = React.useState([]);
  const [experts, setExperts] = React.useState([]);
  const [text, setText] = React.useState("");
  const [text2, setText2] = React.useState("");
  const [selectedUserType, setSelectedUserType] = React.useState({
    name: "all",
    value: "",
    label: "All",
  });

  useEffect(() => {
    const selected =
      userTypeOptions.find((option) => option.value === state.seekerType) ||
      userTypeOptions[0];

    setSelectedUserType(selected);
  }, [state.seekerType]);

  const userTypeOptions = [
    { name: "all", value: "", label: "All" },
    { name: "employee", value: "1", label: "Employee" },
    { name: "customer", value: "2", label: "Customer" },
    { name: "partner", value: "3", label: "Partner" },
  ];
  const onChangeUserType = (e) => {
    setSelectedUserType(e);
    onChangeFunc(e.value, "seekerType");
  };

  const fetchUsers = (text, roles) => {
    if (text.length > 3) {
      if (roles === "seeker") {
        fetchUsers_CM_Atomizer(text, roles).then((res) => {
          if (res === undefined) return;
          if (res.data.success) {
            let updated = res.data.data.users.filter((obj) => {
              obj.value = obj.email;
              return obj;
            });
            if (roles === "seeker") {
              const results =
                state.seekers.length === 0
                  ? updated
                  : updated.filter(
                      (obj) =>
                        !state.seekers.some((obj2) => obj2.email === obj.email),
                    );
              setSeekers(results);
            } else {
              const results =
                state.experts.length === 0
                  ? updated
                  : updated.filter(
                      (obj) =>
                        !state.experts.some((obj2) => obj2.email === obj.email),
                    );
              setExperts(results);
            }
          } else {
            setSeekers([]);
            setExperts([]);
          }
        });
      }
      if (roles === "expert") {
        fetchUsers_demoted(text).then((res) => {
          if (res === undefined) return;
          if (res.data.success) {
            let updated = res.data.data.users.filter((obj) => {
              obj.value = obj.email;
              return obj;
            });
            if (roles === "seeker") {
              const results =
                state.seekers.length === 0
                  ? updated
                  : updated.filter(
                      (obj) =>
                        !state.seekers.some((obj2) => obj2.email === obj.email),
                    );
              setSeekers(results);
            } else {
              const results =
                state.experts.length === 0
                  ? updated
                  : updated.filter(
                      (obj) =>
                        !state.experts.some((obj2) => obj2.email === obj.email),
                    );
              setExperts(results);
            }
          } else {
            setSeekers([]);
            setExperts([]);
          }
        });
      }
    } else {
      setSeekers([]);
      setExperts([]);
    }
  };
  const onSelectSeeker = (data) => {
    setText("");
    let newData = seekers.filter((obj) => {
      if (obj.email === data) {
        return obj;
      }
    });
    onChangeFunc(newData, "seekers");
    setSeekers([]);
  };
  const onBlurSeeker = () => {
    setText("");
    setSeekers([]);
  };

  const onSelectExpert = (data) => {
    setText2("");
    let newData = experts.filter((obj) => {
      if (obj.email === data) {
        return obj;
      }
    });
    onChangeFunc(newData, "experts");
    setExperts([]);
  };
  const onBlurExpert = () => {
    setText2("");
    setExperts([]);
  };
  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        <span
          style={{
            width: "25%",
            marginRight: "10px",
            marginBottom: "10px",
            textAlign: "start",
          }}
        >
          <span
            style={{ fontSize: "14px", color: "#2A364A", fontWeight: "300" }}
          >
            Seeker Type&nbsp;
          </span>
        </span>

        <span className="py-1" style={{ width: "65%", textAlign: "start" }}>
          <MultiSelectCm
            isMulti={false}
            value={selectedUserType}
            options={userTypeOptions}
            onChangeFunc={onChangeUserType}
          />
        </span>
      </div>
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        <span style={{ width: "25%", marginRight: "10px", textAlign: "start" }}>
          <span
            style={{ fontSize: "14px", color: "#2A364A", fontWeight: "300" }}
          >
            Seeker ID&nbsp;
          </span>
        </span>
        <span className="py-1" style={{ width: "65%", textAlign: "start" }}>
          <AutoComplete
            onChange={(e) => setText(e)}
            onBlur={onBlurSeeker}
            value={text}
            onSelect={(data) => onSelectSeeker(data)}
            size="small"
            options={seekers}
            onSearch={(e) => fetchUsers(e, "seeker")}
            placeholder="Enter seeker name or seeker email"
            style={{
              width: "100%",
            }}
          />
        </span>{" "}
      </div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {state.seekers.map((obj) => {
          return (
            <Tag
              closeIcon={<CloseCircleOutlined />}
              onClose={(e) => {
                e.preventDefault();
                onRemoveFunc(obj, "seeker");
              }}
              style={{ fontSize: "10px", marginTop: "10px" }}
            >
              {obj.email}
            </Tag>
          );
        })}
      </div>

      <Divider style={{ marginBlock: "10px" }} />

      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        <span style={{ width: "25%", marginRight: "10px", textAlign: "start" }}>
          <span
            style={{ fontSize: "14px", color: "#2A364A", fontWeight: "300" }}
          >
            Expert ID&nbsp;
          </span>
        </span>
        <span className="py-1" style={{ width: "65%", textAlign: "start" }}>
          <AutoComplete
            onChange={(e) => setText2(e)}
            onBlur={onBlurExpert}
            value={text2}
            onSelect={(data) => onSelectExpert(data)}
            size="small"
            options={experts}
            onSearch={(e) => fetchUsers(e, "expert")}
            placeholder="Enter expert name or expert email"
            style={{
              width: "100%",
            }}
          />
        </span>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {state.experts.map((obj) => {
          return (
            <Tag
              closeIcon={<CloseCircleOutlined />}
              onClose={(e) => {
                e.preventDefault();
                onRemoveFunc(obj, "expert");
              }}
              style={{ fontSize: "10px", marginTop: "10px" }}
            >
              {obj.email}
            </Tag>
          );
        })}
      </div>
    </div>
  );
}
